export const EnglishFormal = [
  {
    sentence:
      "I am pleased to announce that I have completed the {COURSE_TITLE} course on FaraDars and received my certificate.",
    tone: "formal",
    course_title: true,
    lang: "en",
    using_emoji: false,
  },
  {
    sentence:
      "With pride, I have completed the {COURSE_TITLE} course on FaraDars and received my certification.",
    tone: "formal",
    course_title: true,
    lang: "en",
    using_emoji: false,
  },
  {
    sentence:
      "Successfully finished the {COURSE_TITLE} course on FaraDars and received my official certificate.",
    tone: "formal",
    course_title: true,
    lang: "en",
    using_emoji: false,
  },
  {
    sentence:
      "It is with pleasure that I announce the completion of the {COURSE_TITLE} course on FaraDars and the acquisition of my certificate.",
    tone: "formal",
    course_title: true,
    lang: "en",
    using_emoji: false,
  },
  {
    sentence:
      "I am thrilled to have completed the {COURSE_TITLE} course on FaraDars and to have received my certification.",
    tone: "formal",
    course_title: true,
    lang: "en",
    using_emoji: false,
  },
  {
    sentence:
      "After successfully completing the {COURSE_TITLE} course on FaraDars, I have obtained my certificate.",
    tone: "formal",
    course_title: true,
    lang: "en",
    using_emoji: false,
  },
  {
    sentence:
      "I am proud to announce the completion of the {COURSE_TITLE} course on FaraDars and the acquisition of my certificate.",
    tone: "formal",
    course_title: true,
    lang: "en",
    using_emoji: false,
  },
  {
    sentence:
      "Proud to share that I have completed the {COURSE_TITLE} course on FaraDars and earned my certificate.",
    tone: "formal",
    course_title: true,
    lang: "en",
    using_emoji: false,
  },
  {
    sentence:
      "Happy to have completed the {COURSE_TITLE} course on FaraDars and received my certificate.",
    tone: "formal",
    course_title: true,
    lang: "en",
    using_emoji: false,
  },
  {
    sentence:
      "I am honored to announce that I have completed the {COURSE_TITLE} course on FaraDars and received my certification.",
    tone: "formal",
    course_title: true,
    lang: "en",
    using_emoji: false,
  },
  {
    sentence:
      "I proudly received my certificate upon completing the {COURSE_TITLE} course on FaraDars.",
    tone: "formal",
    course_title: true,
    lang: "en",
    using_emoji: false,
  },
  {
    sentence:
      "After successfully completing the {COURSE_TITLE} course on FaraDars, I received my official certification.",
    tone: "formal",
    course_title: true,
    lang: "en",
    using_emoji: false,
  },
  {
    sentence:
      "I am excited to announce that I have completed the {COURSE_TITLE} course on FaraDars and earned my certificate.",
    tone: "formal",
    course_title: true,
    lang: "en",
    using_emoji: false,
  },
  {
    sentence:
      "With great enthusiasm, I completed the {COURSE_TITLE} course on FaraDars and obtained my certification.",
    tone: "formal",
    course_title: true,
    lang: "en",
    using_emoji: false,
  },
  {
    sentence:
      "Successfully concluded the {COURSE_TITLE} course on FaraDars and received my official certificate.",
    tone: "formal",
    course_title: true,
    lang: "en",
    using_emoji: false,
  },
  {
    sentence:
      "I am pleased to announce that I have completed a course on FaraDars and received my certificate.",
    tone: "formal",
    course_title: false,
    lang: "en",
    using_emoji: false,
  },
  {
    sentence:
      "Proud to have finished a course on FaraDars and received my certification.",
    tone: "formal",
    course_title: false,
    lang: "en",
    using_emoji: false,
  },
  {
    sentence:
      "Successfully completed a course on FaraDars, earning my certificate.",
    tone: "formal",
    course_title: false,
    lang: "en",
    using_emoji: false,
  },
  {
    sentence:
      "It is with pleasure that I announce the completion of a course on FaraDars and the acquisition of my certificate.",
    tone: "formal",
    course_title: false,
    lang: "en",
    using_emoji: false,
  },
  {
    sentence:
      "I am thrilled to have completed a course on FaraDars and to have received my certification.",
    tone: "formal",
    course_title: false,
    lang: "en",
    using_emoji: false,
  },
  {
    sentence:
      "After successfully completing a course on FaraDars, I have obtained my certificate.",
    tone: "formal",
    course_title: false,
    lang: "en",
    using_emoji: false,
  },
  {
    sentence:
      "I am proud to announce the completion of a course on FaraDars and the acquisition of my certificate.",
    tone: "formal",
    course_title: false,
    lang: "en",
    using_emoji: false,
  },
  {
    sentence:
      "Proud to share that I have completed a course on FaraDars and earned my certificate.",
    tone: "formal",
    course_title: false,
    lang: "en",
    using_emoji: false,
  },
  {
    sentence:
      "Happy to have completed a course on FaraDars and received my certificate.",
    tone: "formal",
    course_title: false,
    lang: "en",
    using_emoji: false,
  },
  {
    sentence:
      "I am honored to announce that I have completed a course on FaraDars and received my certification.",
    tone: "formal",
    course_title: false,
    lang: "en",
    using_emoji: false,
  },
  {
    sentence:
      "I proudly received my certificate upon completing a course on FaraDars.",
    tone: "formal",
    course_title: false,
    lang: "en",
    using_emoji: false,
  },
  {
    sentence:
      "After successfully completing a course on FaraDars, I received my official certification.",
    tone: "formal",
    course_title: false,
    lang: "en",
    using_emoji: false,
  },
  {
    sentence:
      "I am excited to announce that I have completed a course on FaraDars and earned my certificate.",
    tone: "formal",
    course_title: false,
    lang: "en",
    using_emoji: false,
  },
  {
    sentence:
      "With great enthusiasm, I completed a course on FaraDars and obtained my certification.",
    tone: "formal",
    course_title: false,
    lang: "en",
    using_emoji: false,
  },
  {
    sentence:
      "Successfully concluded a course on FaraDars and received my official certificate.",
    tone: "formal",
    course_title: false,
    lang: "en",
    using_emoji: false,
  },
];
